export default __webpack_public_path__ + "static/Step-6-a4f972bbf5562c8ba14777672cfaaa70.svg";